import { useParams } from 'react-router-dom'
import { SellerAccounting as SellerAccountingComponent } from 'components/sellers/SellerAccounting/SellerAccounting'

export const SellerAccounting: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerAccountingComponent type='seller' sellerId={id as string} />
}